import * as XLSX from 'xlsx';

/**
 * @param {string} fileBaseName - without extension
 * @param {string} sheetName - max 31 chars, invalid chars stripped
 * @param {Record<string, unknown>[]} rows - array of plain objects (column titles = keys)
 */
export function exportRowsToExcel(fileBaseName, sheetName, rows) {
  if (!Array.isArray(rows) || rows.length === 0) return false;
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  const invalidSheetChars = /[\][:*?/\\]/g;
  const safe =
    String(sheetName || 'Export')
      .replace(invalidSheetChars, '')
      .slice(0, 31)
      .trim() || 'Export';
  XLSX.utils.book_append_sheet(wb, ws, safe);
  const fname = fileBaseName.toLowerCase().endsWith('.xlsx') ? fileBaseName : `${fileBaseName}.xlsx`;
  XLSX.writeFile(wb, fname);
  return true;
}
